module.exports = __webpack_public_path__ + "static/media/crown-icon.95be5aad.svg";